/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { bulkUpdateCatalogEntryOverrides } from '../fn/products/bulk-update-catalog-entry-overrides';
import { BulkUpdateCatalogEntryOverrides$Params } from '../fn/products/bulk-update-catalog-entry-overrides';
import { catalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet } from '../fn/products/catalog-entries-modifier-groups-catalog-entry-id-relationships-get';
import { CatalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet$Params } from '../fn/products/catalog-entries-modifier-groups-catalog-entry-id-relationships-get';
import { catalogEntriesProductsCatalogEntryIdPut } from '../fn/products/catalog-entries-products-catalog-entry-id-put';
import { CatalogEntriesProductsCatalogEntryIdPut$Params } from '../fn/products/catalog-entries-products-catalog-entry-id-put';
import { MarkupOverrideBulkResult } from '../models/markup-override-bulk-result';
import { ProductResponse } from '../models/product-response';
import { Products } from '../models/products';
import { tenantsTenantIdCatalogEntriesProductsGet } from '../fn/products/tenants-tenant-id-catalog-entries-products-get';
import { TenantsTenantIdCatalogEntriesProductsGet$Params } from '../fn/products/tenants-tenant-id-catalog-entries-products-get';
import { tenantsTenantIdCatalogEntriesProductsPost } from '../fn/products/tenants-tenant-id-catalog-entries-products-post';
import { TenantsTenantIdCatalogEntriesProductsPost$Params } from '../fn/products/tenants-tenant-id-catalog-entries-products-post';

@Injectable({ providedIn: 'root' })
export class ProductsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tenantsTenantIdCatalogEntriesProductsGet()` */
  static readonly TenantsTenantIdCatalogEntriesProductsGetPath = '/tenants/{tenantId}/catalog-entries/products';

  /**
   * Gets a list of Catalog Products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsTenantIdCatalogEntriesProductsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsTenantIdCatalogEntriesProductsGet$Response(params: TenantsTenantIdCatalogEntriesProductsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Products>> {
    return tenantsTenantIdCatalogEntriesProductsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of Catalog Products.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsTenantIdCatalogEntriesProductsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsTenantIdCatalogEntriesProductsGet(params: TenantsTenantIdCatalogEntriesProductsGet$Params, context?: HttpContext): Observable<Products> {
    return this.tenantsTenantIdCatalogEntriesProductsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Products>): Products => r.body)
    );
  }

  /** Path part for operation `tenantsTenantIdCatalogEntriesProductsPost()` */
  static readonly TenantsTenantIdCatalogEntriesProductsPostPath = '/tenants/{tenantId}/catalog-entries/products';

  /**
   * Creates a product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsTenantIdCatalogEntriesProductsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsTenantIdCatalogEntriesProductsPost$Response(params: TenantsTenantIdCatalogEntriesProductsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductResponse>> {
    return tenantsTenantIdCatalogEntriesProductsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsTenantIdCatalogEntriesProductsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsTenantIdCatalogEntriesProductsPost(params: TenantsTenantIdCatalogEntriesProductsPost$Params, context?: HttpContext): Observable<ProductResponse> {
    return this.tenantsTenantIdCatalogEntriesProductsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductResponse>): ProductResponse => r.body)
    );
  }

  /** Path part for operation `catalogEntriesProductsCatalogEntryIdPut()` */
  static readonly CatalogEntriesProductsCatalogEntryIdPutPath = '/catalog-entries/products/{catalogEntryId}';

  /**
   * Updates a product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `catalogEntriesProductsCatalogEntryIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  catalogEntriesProductsCatalogEntryIdPut$Response(params: CatalogEntriesProductsCatalogEntryIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductResponse>> {
    return catalogEntriesProductsCatalogEntryIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a product.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `catalogEntriesProductsCatalogEntryIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  catalogEntriesProductsCatalogEntryIdPut(params: CatalogEntriesProductsCatalogEntryIdPut$Params, context?: HttpContext): Observable<ProductResponse> {
    return this.catalogEntriesProductsCatalogEntryIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProductResponse>): ProductResponse => r.body)
    );
  }

  /** Path part for operation `catalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet()` */
  static readonly CatalogEntriesModifierGroupsCatalogEntryIdRelationshipsGetPath = '/catalog-entries/modifier-groups/{catalogEntryId}/relationships';

  /**
   * Gets all products that contain a given modifier group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `catalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  catalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet$Response(params: CatalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Products>> {
    return catalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all products that contain a given modifier group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `catalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  catalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet(params: CatalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet$Params, context?: HttpContext): Observable<Products> {
    return this.catalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Products>): Products => r.body)
    );
  }

  /** Path part for operation `bulkUpdateCatalogEntryOverrides()` */
  static readonly BulkUpdateCatalogEntryOverridesPath = '/stores/{storeId}/catalog-entry-overrides/bulk-updates';

  /**
   * Bulk updates a Product Override for the a Store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bulkUpdateCatalogEntryOverrides()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkUpdateCatalogEntryOverrides$Response(params: BulkUpdateCatalogEntryOverrides$Params, context?: HttpContext): Observable<StrictHttpResponse<MarkupOverrideBulkResult>> {
    return bulkUpdateCatalogEntryOverrides(this.http, this.rootUrl, params, context);
  }

  /**
   * Bulk updates a Product Override for the a Store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bulkUpdateCatalogEntryOverrides$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  bulkUpdateCatalogEntryOverrides(params: BulkUpdateCatalogEntryOverrides$Params, context?: HttpContext): Observable<MarkupOverrideBulkResult> {
    return this.bulkUpdateCatalogEntryOverrides$Response(params, context).pipe(
      map((r: StrictHttpResponse<MarkupOverrideBulkResult>): MarkupOverrideBulkResult => r.body)
    );
  }

}
